// extracted by mini-css-extract-plugin
export default {"container":"TopicIcon-module__container--y0Ohw","animatedBackground":"TopicIcon-module__animatedBackground--6wU2q"};